export default __webpack_public_path__ + "static/media/ham.9f8d8d58.svg";